module.exports = __webpack_public_path__ + "img/coffeetogosmall.70fec2b5.jpg";